import { matchRoutes } from "react-router";

export const CHAT_PATH = "/organizations/chat";
export const CHAT_HISTORY_SEGMENT = "history";
export const CHAT_HISTORY_PATH = `${CHAT_PATH}/${CHAT_HISTORY_SEGMENT}`;
export const CHAT_HISTORY_SHARED_PATH = `${CHAT_HISTORY_PATH}/shared`;

export type ChatHistoryTab = "chats" | "shared";

const historyRoutes: { path: string; tab: ChatHistoryTab }[] = [
    { path: CHAT_HISTORY_PATH, tab: "chats" },
    { path: CHAT_HISTORY_SHARED_PATH, tab: "shared" },
];

export function getChatHistoryTab(pathname: string): ChatHistoryTab | null {
    return matchRoutes(historyRoutes, { pathname })?.[0]?.route.tab ?? null;
}
